export default __webpack_public_path__ + "decode-audio.wasm";